import React from 'react';
import './LegalPages.css';

const TermsAndConditions = () => {
    return (
        <div className="legal-page-container">
            {/* 1. Header Banner */}
            <section className="legal-hero-banner">
                <h1 className="legal-hero-title">TERMS & CONDITIONS</h1>
                <p className="legal-hero-effective-date">Effective Date: July 18, 2026</p>
            </section>

            {/* 2. Main Body Content */}
            <div className="legal-content-wrapper">
                <div className="legal-container-max">
                    <p className="legal-paragraph">
                        Welcome to Iconic Unity Group. By accessing our official website, submitting business proposals, entering into corporate partnerships, or engaging with our platform and sister concerns, you acknowledge that you have read, understood, and agreed to be bound by these Terms and Conditions.
                    </p>

                    <h3 className="legal-section-title">1. Corporate Scope & Platform Operations</h3>
                    <p className="legal-paragraph">
                        Iconic Unity Group (IUG) functions as a diversified business platform and holding corporate structure overseeing multiple strategic entities (including Transportation, Real Estate, Digital Solutions, Software/IT, Furniture Manufacturing, Travel & Tourism, Automotive, and Logistics). Detailed contractual scope, SLA, and commercial terms for specific services are defined under independent operational agreements with respective sister concerns.
                    </p>

                    <h3 className="legal-section-title">2. Partnership & Investment Proposals</h3>
                    <p className="legal-paragraph">
                        Submitting a business proposal, joint venture query, or equity partnership request through our website does not automatically constitute a binding legal agreement. All proposals undergo strict due diligence, evaluation by our Executive Board, and require formal legal documentation prior to execution.
                    </p>

                    <h3 className="legal-section-title">3. Intellectual Property & Brand Assets</h3>
                    <ul className="legal-bullet-list">
                        <li><strong>Group Assets:</strong> All trademarks, logos, domain names, corporate graphics, and web content associated with Iconic Unity Group and its brand subsidiaries remain the exclusive intellectual property of IUG.</li>
                        <li><strong>Restrictions:</strong> Unauthorized reproduction, alteration, or distribution of our brand identity or proprietary materials without prior written authorization is strictly prohibited.</li>
                    </ul>

                    <h3 className="legal-section-title">4. Confidentiality & Non-Disclosure</h3>
                    <p className="legal-paragraph">
                        Any strategic business ideas, financial models, or trade secrets shared with Iconic Unity Group during corporate discussions are treated with strict professional confidentiality. Both parties agree not to disclose proprietary details to external unauthorized parties.
                    </p>

                    <h3 className="legal-section-title">5. Limitation of Liability</h3>
                    <p className="legal-paragraph">
                        Iconic Unity Group provides platform information on an "as is" basis. While we strive for accuracy, we shall not be held liable for indirect, incidental, or consequential damages resulting from website downtime, third-party link interactions, or preliminary strategic decisions made prior to signing binding corporate contracts.
                    </p>

                    <h3 className="legal-section-title">6. Governing Law & Dispute Resolution</h3>
                    <p className="legal-paragraph">
                        These Terms and Conditions shall be governed by and construed in accordance with the laws of the People's Republic of Bangladesh. Any dispute arising out of or in connection with these terms shall be settled through mutual negotiation or jurisdiction in Dhaka, Bangladesh courts.
                    </p>

                    <h3 className="legal-section-title">7. Amendments to Terms</h3>
                    <p className="legal-paragraph">
                        We reserve the right to amend or update these Terms & Conditions at any time to reflect changing regulations or corporate policies. The "Effective Date" at the top indicates the latest revision.
                    </p>

                    <hr className="legal-divider" />

                    {/* Contact Section */}
                    <div className="legal-contact-section">
                        <h3 className="legal-section-title">8. Contact Information</h3>
                        <p className="legal-paragraph">
                            For any corporate inquiries, official notices, or legal clarifications, please reach out to:
                        </p>
                        <div className="legal-contact-details">
                            <strong>Iconic Unity Group</strong><br />
                            <strong>Address:</strong> Suite: 8/A&B, LilyPond Center, 3, R. K. Mission Road, Motijheel, Dhaka-1000, Bangladesh<br />
                            <strong>Hotline:</strong> <span id='info-color'>01824800900</span> | <strong>Phone:</strong> <span id='info-color'>01711183777</span><br />
                            <strong>Email:</strong> <span id='info-color'>info@iconicunitygroup.com</span><br />
                            <strong>Website:</strong> <span id='info-color'>www.iconicunitygroup.com</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default TermsAndConditions;